"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _ConfirmModal = require("web/shared/components/ConfirmModal.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* A small centered confirmation dialog for destructive or irreversible
* actions. The parent owns the open state and the confirm/cancel handlers;
* this component is presentational plus the minimal modal behavior (a dimmed
* backdrop that cancels on click, and an Escape-to-cancel key handler).
*
* It renders nothing when closed. While `busy` (the confirm action is in
* flight) the buttons and backdrop are inert so the action can't be
* double-fired or dismissed mid-flight.
*/
function ConfirmModal(props) {
  const open = props.open,
    busy = props.busy,
    onCancel = props.onCancel;
  (0, _react.useEffect)(() => {
    if (!open) {
      return undefined;
    }
    const onKeyDown = event => {
      if (event.key === "Escape" && busy !== true) {
        onCancel();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, busy, onCancel]);
  if (!open) {
    return null;
  }
  const confirmLabel = props.confirmLabel != null && props.confirmLabel !== "" ? props.confirmLabel : "Delete";
  const cancelLabel = props.cancelLabel != null && props.cancelLabel !== "" ? props.cancelLabel : "Cancel";
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ConfirmModal.styles.overlay)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)({
      type: "button",
      "aria-hidden": "true",
      tabIndex: -1,
      onClick: () => {
        if (busy !== true) {
          onCancel();
        }
      }
    }, stylex.props(_ConfirmModal.styles.backdrop))), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({
      role: "dialog",
      "aria-modal": "true",
      "aria-label": props.title
    }, stylex.props(_ConfirmModal.styles.dialog)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ConfirmModal.styles.title)), {}, {
        children: props.title
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ConfirmModal.styles.message)), {}, {
        children: props.message
      })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ConfirmModal.styles.actions)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
          type: "button",
          onClick: onCancel,
          disabled: busy
        }, stylex.props(_ConfirmModal.styles.button, _ConfirmModal.styles.cancel, busy === true && _ConfirmModal.styles.busy)), {}, {
          children: cancelLabel
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
          type: "button",
          onClick: props.onConfirm,
          disabled: busy
        }, stylex.props(_ConfirmModal.styles.button, _ConfirmModal.styles.danger, busy === true && _ConfirmModal.styles.busy)), {}, {
          children: busy === true ? "Deleting…" : confirmLabel
        }))]
      }))]
    }))]
  }));
}
var _default = exports.default = ConfirmModal;